<div class="data-wrapper">
    <div class="edit-mode">
        <form [formGroup]="personalForm">
            <div class="personal-data-wrapper">
                <div class="top">
                    <div class="group">
                        <h4 [innerHTML]="formTitle"></h4>
                    </div>
                    <div class="data-group">
                        <div class="group" *ngIf="salutations$ | async as salutations">
                            <label
                                for="salutation{{ index }}"
                                [class.active]="hasFocusSalutation || hasValue(f.salutation)"
                                [class.hasvalue]="!hasFocusSalutation && hasValue(f.salutation)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'personalData.salutation' | translate"></span></span>
                                <div class="select-wrapper">
                                    <select
                                        formControlName="salutation"
                                        id="salutation{{ index }}"
                                        (focus)="hasFocusSalutation = true"
                                        (blur)="hasFocusSalutation = false"
                                        (change)="onKey($event.target.value)"
                                        [(ngModel)]="selectedSalutation"
                                        [disabled]="salutations.length <= 1"
                                    >
                                        <option *ngFor="let item of salutations" [value]="item.code">{{ item.name }}</option>
                                    </select>
                                </div>
                            </label>

                            <div *ngIf="submitted && f.salutation.errors" class="invalid-feedback">
                                <div *ngIf="f.salutation.errors.required" [innerHTML]="'personalData.fieldRequired' | translate"></div>
                            </div>
                        </div>
                        <div class="group mobile">
                            <label
                                for="title{{ index }}"
                                [class.active]="hasFocusTitle || hasValue(f.title)"
                                [class.hasvalue]="!hasFocusTitle && hasValue(f.title)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'personalData.title' | translate"></span></span>
                                <input
                                    formControlName="title"
                                    id="title{{ index }}"
                                    (focus)="hasFocusTitle = true"
                                    (blur)="hasFocusTitle = false"
                                    type="text"
                                />
                            </label>

                            <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                                <div *ngIf="f.title.errors.required" [innerHTML]="'personalData.fieldRequired' | translate"></div>
                            </div>
                        </div>
                    </div>

                    <div class="data-group two-rows">
                        <div class="group">
                            <label
                                for="firstName{{ index }}"
                                [class.active]="hasFocusFirstName || hasValue(f.firstName)"
                                [class.hasvalue]="!hasFocusFirstName && hasValue(f.firstName)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'booking.booking.firstName' | translate"></span>*</span>
                                <input
                                    formControlName="firstName"
                                    id="firstName{{ index }}"
                                    (focus)="hasFocusFirstName = true"
                                    (blur)="hasFocusFirstName = false"
                                    type="text"
                                    maxlength="50"
                                />
                            </label>

                            <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                                <div *ngIf="f.firstName.errors.required" [innerHTML]="'booking.booking.fieldRequired' | translate"></div>
                            </div>
                            <div *ngIf="hasFocusFirstName && f.firstName.value && f.firstName.value.length >= 50" class="invalid-feedback">
                                <div [innerHTML]="'booking.booking.reachedMaxLength' | translate"></div>
                            </div>
                        </div>
                        <div class="group mobile">
                            <label
                                for="lastName{{ index }}"
                                [class.active]="hasFocusLastName || hasValue(f.lastName)"
                                [class.hasvalue]="!hasFocusLastName && hasValue(f.lastName)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'booking.booking.lastName' | translate"></span>*</span>
                                <input
                                    formControlName="lastName"
                                    id="lastName{{ index }}"
                                    (focus)="hasFocusLastName = true"
                                    (blur)="hasFocusLastName = false"
                                    type="text"
                                    maxlength="35"
                                />
                            </label>

                            <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                                <div *ngIf="f.lastName.errors.required" [innerHTML]="'booking.booking.fieldRequired' | translate"></div>
                            </div>
                            <div *ngIf="hasFocusLastName && f.lastName.value && f.lastName.value.length >= 35" class="invalid-feedback">
                                <div [innerHTML]="'booking.booking.reachedMaxLength' | translate"></div>
                            </div>
                        </div>
                    </div>

                    <div class="data-group two-rows">
                        <!-- <div class="group">
                            <label
                                for="email"
                                [class.active]="hasFocusEmail || hasValue(f.email)"
                                [class.hasvalue]="!hasFocusEmail && hasValue(f.email)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'booking.booking.email' | translate"></span>*</span>
                                <input
                                    formControlName="email"
                                    id="email"
                                    (focus)="hasFocusEmail = true"
                                    (blur)="hasFocusEmail = false"
                                    type="text"
                                />
                            </label>

                            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                <div *ngIf="f.email.errors.required" [innerHTML]="'booking.booking.fieldRequired' | translate"></div>
                            </div>
                        </div> -->
                        <div class="group">
                            <label
                                for="phone{{ index }}"
                                [class.active]="hasFocusPhone || hasValue(f.phone)"
                                [class.hasvalue]="!hasFocusPhone && hasValue(f.phone)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'booking.booking.phone' | translate"></span></span>
                                <input
                                    formControlName="phone"
                                    id="phone{{ index }}"
                                    (focus)="hasFocusPhone = true"
                                    (blur)="hasFocusPhone = false"
                                    type="text"
                                />
                            </label>
                            <div *ngIf="submitted && f.phone.errors" class="invalid-feedback">
                                <div *ngIf="f.phone.errors.required" [innerHTML]="'booking.booking.fieldRequired' | translate"></div>
                            </div>
                        </div>
                        <div class="group mobile">
                            <label
                                for="department{{ index }}"
                                [class.active]="hasFocusDepartment || hasValue(f.department)"
                                [class.hasvalue]="!hasFocusDepartment && hasValue(f.department)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'personalData.department' | translate"></span></span>
                                <input
                                    formControlName="department"
                                    id="department{{ index }}"
                                    (focus)="hasFocusDepartment = true"
                                    (blur)="hasFocusDepartment = false"
                                    type="text"
                                    maxlength="20"
                                />
                            </label>

                            <div *ngIf="submitted && f.department.errors" class="invalid-feedback">
                                <div *ngIf="f.department.errors.required" [innerHTML]="'personalData.fieldRequired' | translate"></div>
                            </div>
                            <div
                                *ngIf="hasFocusDepartment && f.department.value && f.department.value.length >= 20"
                                class="invalid-feedback"
                            >
                                <div [innerHTML]="'booking.booking.reachedMaxLength' | translate"></div>
                            </div>
                        </div>
                    </div>

                    <div class="data-group two-rows">
                        <div class="group">
                            <label
                                for="email{{ index }}"
                                [class.active]="hasFocusEmail || hasValue(f.email)"
                                [class.hasvalue]="!hasFocusEmail && hasValue(f.email)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'booking.booking.email' | translate"></span>*</span>
                                <input
                                    formControlName="email"
                                    id="email{{ index }}"
                                    (focus)="hasFocusEmail = true"
                                    (blur)="hasFocusEmail = false"
                                    type="text"
                                    maxlength="100"
                                />
                            </label>

                            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                <div *ngIf="f.email.errors.required" [innerHTML]="'booking.booking.fieldRequired' | translate"></div>
                                <div *ngIf="f.email.errors.email" [innerHTML]="'login.emailFormat' | translate"></div>
                            </div>
                            <div *ngIf="hasFocusEmail && f.email.value && f.email.value.length >= 100" class="invalid-feedback">
                                <div [innerHTML]="'booking.booking.reachedMaxLength' | translate"></div>
                            </div>
                        </div>
                        <div class="group"></div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="group">
                        <h5 [innerHTML]="'booking.booking.companyTitle' | translate"></h5>
                    </div>

                    <div class="data-group full-width" *ngIf="isBookingPerson && index !== 0 && !hideSameAsCompany">
                        <div class="group">
                            <label class="checkboxlabel">
                                <input
                                    type="checkbox"
                                    id="subscribe{{ index }}"
                                    formControlName="companySameAs"
                                    (change)="companySameAs($event.target.checked)"
                                />
                                <label
                                    *ngIf="!isBillingContact"
                                    for="subscribe{{ index }}"
                                    class="subscribe-me"
                                    [innerHTML]="'booking.bookingParticipants.companySameAs' | translate"
                                ></label>
                                <label
                                    *ngIf="isBillingContact"
                                    for="subscribe{{ index }}"
                                    class="subscribe-me"
                                    [innerHTML]="'booking.booking.sameAsCompany' | translate"
                                ></label>
                            </label>
                        </div>
                    </div>

                    <div class="data-group">
                        <div class="group">
                            <label
                                for="company{{ index }}"
                                [class.active]="hasFocusCompany || hasValue(f.company)"
                                [class.hasvalue]="!hasFocusCompany && hasValue(f.company)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'personalData.company' | translate"></span>*</span>
                                <input
                                    formControlName="company"
                                    id="company{{ index }}"
                                    (focus)="hasFocusCompany = true"
                                    (blur)="hasFocusCompany = false"
                                    type="text"
                                    (keyup)="onKey($event.target.value)"
                                    maxlength="50"
                                />
                            </label>
                            <div *ngIf="submitted && f.company.errors" class="invalid-feedback">
                                <div *ngIf="f.company.errors.required" [innerHTML]="'personalData.fieldRequired' | translate"></div>
                            </div>
                            <div *ngIf="hasFocusCompany && f.company.value && f.company.value.length >= 50" class="invalid-feedback">
                                <div [innerHTML]="'booking.booking.reachedMaxLength' | translate"></div>
                            </div>
                        </div>
                        <div class="group"></div>
                    </div>

                    <div class="data-group">
                        <!-- <div class="group">
                            <label
                                for="address{{ index }}"
                                [class.active]="hasFocusAddress || hasValue(f.address)"
                                [class.hasvalue]="!hasFocusAddress && hasValue(f.address)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'personalData.address' | translate"></span>*</span>
                                <input
                                    formControlName="address"
                                    id="address{{ index }}"
                                    (focus)="hasFocusAddress = true"
                                    (blur)="hasFocusAddress = false"
                                    type="text"
                                    (keyup)="onKey($event.target.value)"
                                    maxlength="50"
                                />
                            </label>
                            <div *ngIf="submitted && f.address.errors" class="invalid-feedback">
                                <div *ngIf="f.address.errors.required" [innerHTML]="'personalData.fieldRequired' | translate"></div>
                            </div>
                            <div *ngIf="hasFocusAddress && f.address.value && f.address.value.length >= 50" class="invalid-feedback">
                                <div [innerHTML]="'booking.booking.reachedMaxLength' | translate"></div>
                            </div>
                        </div> -->
                        <div class="group">
                            <label
                                for="address{{ index }}"
                                [class.active]="hasFocusAddress || hasValue(f.address)"
                                [class.hasvalue]="!hasFocusAddress && hasValue(f.address)"
                            >
                                <span *ngIf="!loggedIn" class="labelcontent"><span [innerHTML]="'personalData.street' | translate"></span>*</span>
                                <span *ngIf="loggedIn" class="labelcontent"><span [innerHTML]="'personalData.address' | translate"></span>*</span>
                                <input
                                    formControlName="address"
                                    id="address{{ index }}"
                                    (focus)="hasFocusAddress = true"
                                    (blur)="hasFocusAddress = false"
                                    type="text"
                                    (keyup)="onKey($event.target.value)"
                                    maxlength="50"
                                />
                            </label>
                            <div *ngIf="submitted && f.address.errors" class="invalid-feedback">
                                <div *ngIf="f.address.errors.required" [innerHTML]="'personalData.fieldRequired' | translate"></div>
                            </div>
                            <div *ngIf="hasFocusAddress && f.address.value && f.address.value.length >= 50" class="invalid-feedback">
                                <div [innerHTML]="'booking.booking.reachedMaxLength' | translate"></div>
                            </div>
                        </div>
                        <div *ngIf="!loggedIn" class="group mobile">
                            <label
                                for="houseNumber{{ index }}"
                                [class.active]="hasFocusHouseNumber || hasValue(f.houseNumber)"
                                [class.hasvalue]="!hasFocusHouseNumber && hasValue(f.houseNumber)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'personalData.houseNumber' | translate"></span></span>
                                <input
                                    maxLength="10"
                                    formControlName="houseNumber"
                                    id="houseNumber{{ index }}"
                                    (focus)="hasFocusHouseNumber = true"
                                    (blur)="hasFocusHouseNumber = false"
                                    type="text"
                                    (keyup)="onKey($event.target.value)"
                                    maxlength="10"
                                />
                            </label>
                            <div *ngIf="submitted && f.houseNumber.errors" class="invalid-feedback">
                                <div *ngIf="f.houseNumber.errors.required" [innerHTML]="'personalData.fieldRequired' | translate"></div>
                            </div>
                            <div *ngIf="hasFocusHouseNumber && f.houseNumber.value && f.houseNumber.value.length >= 10" class="invalid-feedback">
                                <div [innerHTML]="'booking.booking.reachedMaxLength' | translate"></div>
                            </div>
                        </div>
                         <!-- <div class="group">
                           <label for="addressAdditional" [class.active]="hasFocusAddressAdditional || hasValue(f.addressAdditional)"
                [class.hasvalue]="!hasFocusAddressAdditional && hasValue(f.addressAdditional)">
                <span class="labelcontent"><span [innerHTML]="'personalData.additionalInfo' | translate"></span></span>
                <input formControlName="addressAdditional" id="addressAdditional"
                  (focus)="hasFocusAddressAdditional = true" (blur)="hasFocusAddressAdditional = false" type="text" />
              </label>
              <div *ngIf="submitted && f.addressAdditional.errors" class="invalid-feedback">
                <div *ngIf="f.addressAdditional.errors.required" [innerHTML]="'personalData.fieldRequired' | translate">
                </div>
              </div>
                        </div> -->
                    </div>

                    <div class="data-group">
                        <div class="group">
                            <label
                                for="city{{ index }}"
                                [class.active]="hasFocusCity || hasValue(f.city)"
                                [class.hasvalue]="!hasFocusCity && hasValue(f.city)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'personalData.city' | translate"></span>*</span>
                                <input
                                    formControlName="city"
                                    id="city{{ index }}"
                                    (focus)="hasFocusCity = true"
                                    (blur)="hasFocusCity = false"
                                    type="text"
                                    (keyup)="onKey($event.target.value)"
                                    maxlength="40"
                                />
                            </label>
                            <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                                <div *ngIf="f.city.errors.required" [innerHTML]="'personalData.fieldRequired' | translate"></div>
                            </div>
                            <div *ngIf="hasFocusCity && f.city.value && f.city.value.length >= 40" class="invalid-feedback">
                                <div [innerHTML]="'booking.booking.reachedMaxLength' | translate"></div>
                            </div>
                        </div>
                        <div class="group mobile">
                            <label
                                for="zipCode{{ index }}"
                                [class.active]="hasFocusZipCode || hasValue(f.zipCode)"
                                [class.hasvalue]="!hasFocusZipCode && hasValue(f.zipCode)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'personalData.zipCode' | translate"></span>*</span>
                                <input
                                    maxLength="10"
                                    formControlName="zipCode"
                                    id="zipCode{{ index }}"
                                    (focus)="hasFocusZipCode = true"
                                    (blur)="hasFocusZipCode = false"
                                    type="text"
                                    (keyup)="onKey($event.target.value)"
                                    maxlength="10"
                                />
                            </label>
                            <div *ngIf="submitted && f.zipCode.errors" class="invalid-feedback">
                                <div *ngIf="f.zipCode.errors.required" [innerHTML]="'personalData.fieldRequired' | translate"></div>
                            </div>
                            <div *ngIf="hasFocusZipCode && f.zipCode.value && f.zipCode.value.length >= 10" class="invalid-feedback">
                                <div [innerHTML]="'booking.booking.reachedMaxLength' | translate"></div>
                            </div>
                        </div>
                    </div>
                    <div class="data-group">
                        <div class="group" [class.mobile]="!(hasRegions$ | async)" *ngIf="countries$ | async as countries">
                            <label
                                for="country{{ index }}"
                                [class.active]="hasFocusCountry || hasValue(f.country)"
                                [class.hasvalue]="!hasFocusCountry && hasValue(f.country)"
                            >
                                <span class="labelcontent"><span [innerHTML]="'personalData.country' | translate"></span>*</span>
                                <div class="select-wrapper">
                                    <select
                                        formControlName="country"
                                        id="country{{ index }}"
                                        (focus)="hasFocusCountry = true"
                                        (blur)="hasFocusCountry = false"
                                        (change)="onKey($event.target.value)"
                                        [(ngModel)]="selectedCountry"
                                        [disabled]="countries.length <= 1"
                                    >
                                        <option *ngFor="let item of countries" [value]="item.code">{{ item.name }}</option>
                                    </select>
                                </div>
                            </label>

                            <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                                <div *ngIf="f.country.errors.required" [innerHTML]="'personalData.fieldRequired' | translate"></div>
                            </div>
                        </div>
                        <ng-container *ngIf="hasRegions$ | async">
                            <div class="group mobile" *ngIf="regions$ | async as regions">
                                <label
                                    for="regionKey{{ index }}"
                                    [class.active]="hasFocusRegion || hasValue(f.regionKey)"
                                    [class.hasvalue]="!hasFocusRegion && hasValue(f.regionKey)"
                                >
                                    <span class="labelcontent"><span [innerHTML]="'personalData.region' | translate"></span>*</span>
                                    <div class="select-wrapper">
                                        <select
                                            formControlName="regionKey"
                                            id="regionKey{{ index }}"
                                            (focus)="hasFocusRegion = true"
                                            (blur)="hasFocusRegion = false"
                                            (change)="onKey($event.target.value)"
                                            [(ngModel)]="selectedRegion"
                                            [disabled]="regions.length <= 1"
                                        >
                                            <option *ngFor="let item of regions" [value]="item">{{ item }}</option>
                                        </select>
                                    </div>
                                </label>

                                <div *ngIf="submitted && f.regionKey.errors" class="invalid-feedback">
                                    <div *ngIf="f.regionKey.errors.required" [innerHTML]="'personalData.fieldRequired' | translate"></div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
